import { memo, useCallback } from 'react';
export const EditableArrayItem = memo(function EditableArrayItem(props) {
    const { itemModel, render, controls } = props;
    const handleRemove = useCallback(() => controls.remove(itemModel.id), [itemModel.id, controls]);
    const handleUpdate = useCallback((entity) => controls.update(itemModel.id, entity), [itemModel.id, controls]);
    return render({
        entity: itemModel.editableEntity,
        removeEntity: handleRemove,
        updateEntity: handleUpdate,
        isValid: itemModel.isValid,
        isDirty: itemModel.isDirty
    });
});
